import { Divider, TableCell, TableRow, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import logo from '../../assets/logo/amex-logo.svg';
import { CSSProperties } from 'react';

function PlacementSlipCustomerDetails({
  rfqDetails,
  offerAcceptView = false,
  placementSlipData = null,
  type = null,
  policyDetail = null
}) {
  useEffect(() => {
    if (rfqDetails.customerData) {
      setCustomerDetails(rfqDetails.customerData);
      setCustomerType(
        rfqDetails?.retailCustomerId ? 'retailCustomer' : 'corporateCustomer'
      );
    } else {
      if (rfqDetails?.retailCustomerId) {
        setCustomerDetails(rfqDetails.retailCustomer);
        setCustomerType('retailCustomer');
      } else if (rfqDetails?.corporateCustomerId) {
        setCustomerBranchDetails(rfqDetails.corporateCustomerBranch);
        setCustomerDetails(rfqDetails.corporateCustomer);
        setCustomerType('corporateCustomer');
      }
    }
  }, [rfqDetails]);
  const [customerDetails, setCustomerDetails] = useState(null);
  const [customerBranch, setCustomerBranchDetails] = useState(null);
  const [customerType, setCustomerType] = useState('');

  const qcCellStyle: CSSProperties = {
    width: '50%',
    maxWidth: '50%',
    overflowWrap: 'break-word',
    minWidth: 0,
    paddingBottom: '4px',
    paddingTop: '4px'
  };

  const placementCellStyle: CSSProperties = {
    width: '36.3vw!important',
    maxWidth: '36.3vw!important',
    overflowWrap: 'break-word',
    minWidth: 0
  };
  const activeCellStyle = type === 'qc' ? qcCellStyle : placementCellStyle;

  return (
    <>
      {type != 'qc' && <>
        <TableRow key={0} className="noBorder">
          <TableCell
            className="tbCol"
            component="th"
            scope="row"
            style={{
              maxWidth: '36.3vw',
              width: '36.3vw',
              wordWrap: 'break-word'
            }}
          >
            <img
              style={{ width: 150, marginTop: '10px', marginBottom: '10px' }}
              src={logo}
              alt={logo}
            />
          </TableCell>
          <TableCell
            className="tbCol"
            style={{
              maxWidth: '250px',
              wordWrap: 'break-word',
              paddingLeft: '2px'
            }}
          >
            <Typography
              variant="h4"
              component="div"
              style={{
                textAlign: 'center',
                display: 'flex',
                alignItems: 'center',
                height: '100%'
              }}
            >
              AM-EX Insurance Brokers (India) Pvt.Ltd.
            </Typography>
          </TableCell>
        </TableRow>
        <TableRow key={1} className="noBorder">
          <TableCell></TableCell>
          <TableCell
            align="right"
            className="tbCol"
            style={{
              maxWidth: '250px',
              wordWrap: 'break-word',
              paddingLeft: '2px'
            }}
          >
            Placement Slip No : {placementSlipData?.[0]?.['placementId']}
          </TableCell>
        </TableRow>
        <TableRow key={1}>
          <TableCell colSpan={2}>
            <div style={{ margin: '0.2%', fontWeight: 'bold' }}>
              <Typography style={{ fontWeight: 'bold' }}>To,</Typography>
              <Typography style={{ fontWeight: 'bold' }}>
                {placementSlipData?.[0]?.rfqOffer?.inscompany?.name}
              </Typography>
              <Typography style={{ fontWeight: 'bold' }}>
                {placementSlipData?.[0]?.rfqOffer?.companyBranch?.billingAddress ? placementSlipData?.[0]?.rfqOffer?.companyBranch?.billingAddress : placementSlipData?.[0]?.rfqOffer?.inscompany?.address}
              </Typography>
              <Typography style={{ fontWeight: 'bold' }} noWrap>
                We are pleased to place with you below mentioned risk as per the
                terms mutually agreed.
              </Typography>
            </div>
          </TableCell>
        </TableRow>
      </>}





      {/* <TableRow key={1} className="noBorder">
        <TableCell
          className="tbCol"
          component="th"
          scope="row"
          style={{
            maxWidth: '36.3vw',
            width: '36.3vw',
            wordWrap: 'break-word'
          }}
        >
          SUB
        </TableCell>
        <TableCell
          className="tbCol"
          style={{
            maxWidth: '250px',
            wordWrap: 'break-word',
            paddingLeft: '2px'
          }}
        >
          {offerAcceptView ? 'COMPARISON OF QUOTES' : 'REQUEST FOR QUOTE'}
        </TableCell>
      </TableRow> */}
      <TableRow key={4} className="noBorder" sx={{ height: '10px' }}>
        <TableCell
          className="tbCol heading"
          colSpan={2}
          style={{
            fontWeight: 'bold',
            textAlign: 'center',
            background: 'rgb(9 84 174)',
            color: '#fff',
            padding: '6px 10px',
            lineHeight: 1,
            fontSize: '0.9rem'
          }}
        >
          {'INSURED DETAILS'}
        </TableCell>
      </TableRow>
      <TableRow key={15} className="noBorder" style={{
        opacity:
          (
            policyDetail?.parentqcData ||
            policyDetail?.insurancePolicy?.qcData
          )?.insured_details?.status === 'approve'
            ? 0.5
            : 1,
        pointerEvents:
          (
            policyDetail?.parentqcData ||
            policyDetail?.insurancePolicy?.qcData
          )?.insured_details?.status === 'approve'
            ? 'none'
            : 'auto',

      }}>
        <TableCell
          className="tbCol"
          component="th"
          scope="row"
          style={activeCellStyle}
        >
          Insured Name
        </TableCell>
        <TableCell
          className="tbCol"
          style={activeCellStyle}
        >
          {customerDetails && (
            <>
              {customerType === 'retailCustomer'
                ? customerDetails?.name ?? 'N/A'
                : customerDetails?.companyName ?? 'N/A'}
            </>
          )}
        </TableCell>
      </TableRow>
      {rfqDetails.secondInsured && (
        <TableRow key={5} className="noBorder"

          style={{
            opacity:
              (
                policyDetail?.parentqcData ||
                policyDetail?.insurancePolicy?.qcData
              )?.insured_details?.status === 'approve'
                ? 0.5
                : 1,
            pointerEvents:
              (
                policyDetail?.parentqcData ||
                policyDetail?.insurancePolicy?.qcData
              )?.insured_details?.status === 'approve'
                ? 'none'
                : 'auto',

          }}
        >
          <TableCell
            className="tbCol"
            component="th"
            scope="row"
            style={activeCellStyle}
          >
            Second Insured Name
          </TableCell>
          <TableCell
            className="tbCol"
            style={activeCellStyle}
          >
            {rfqDetails.secondInsured}
          </TableCell>
        </TableRow>
      )}
      {!offerAcceptView && (
        <>
          <TableRow key={7} className="noBorder"

            style={{
              opacity:
                (
                  policyDetail?.parentqcData ||
                  policyDetail?.insurancePolicy?.qcData
                )?.insured_details?.status === 'approve'
                  ? 0.5
                  : 1,
              pointerEvents:
                (
                  policyDetail?.parentqcData ||
                  policyDetail?.insurancePolicy?.qcData
                )?.insured_details?.status === 'approve'
                  ? 'none'
                  : 'auto',

            }}
          >
            <TableCell
              className="tbCol"
              component="th"
              scope="row"
              style={activeCellStyle}
            >
              Address
            </TableCell>
            <TableCell
              className="tbCol"
              style={activeCellStyle}
            >
              {customerType === 'corporateCustomer' && (
                <>
                  {' '}
                  {customerBranch?.billingAddress
                    ? customerBranch?.billingAddress : customerDetails?.billingAddress ? customerDetails?.billingAddress
                      : 'N/A'}
                </>
              )}

              {customerType === 'retailCustomer' && (
                <>
                  {' '}
                  {customerDetails?.address ? customerDetails?.address : 'N/A'}
                </>
              )}
            </TableCell>
          </TableRow>
          <TableRow key={6} className="noBorder"
            style={{
              opacity:
                (
                  policyDetail?.parentqcData ||
                  policyDetail?.insurancePolicy?.qcData
                )?.insured_details?.status === 'approve'
                  ? 0.5
                  : 1,
              pointerEvents:
                (
                  policyDetail?.parentqcData ||
                  policyDetail?.insurancePolicy?.qcData
                )?.insured_details?.status === 'approve'
                  ? 'none'
                  : 'auto',

            }}
          >
            <TableCell
              className="tbCol"
              component="th"
              scope="row"
              style={activeCellStyle}
            >
              City
            </TableCell>
            <TableCell
              className="tbCol"
              style={activeCellStyle}
            >

              {customerBranch?.city
                ? customerBranch?.city : customerDetails?.city ? customerDetails?.city
                  : 'N/A'}

            </TableCell>
          </TableRow>
          <TableRow key={8} className="noBorder"
            style={{
              opacity:
                (
                  policyDetail?.parentqcData ||
                  policyDetail?.insurancePolicy?.qcData
                )?.insured_details?.status === 'approve'
                  ? 0.5
                  : 1,
              pointerEvents:
                (
                  policyDetail?.parentqcData ||
                  policyDetail?.insurancePolicy?.qcData
                )?.insured_details?.status === 'approve'
                  ? 'none'
                  : 'auto',

            }}
          >
            <TableCell
              className="tbCol"
              component="th"
              scope="row"
              style={activeCellStyle}
            >
              GST No
            </TableCell>
            <TableCell
              className="tbCol"
              style={activeCellStyle}
            >

              {customerBranch?.gstNo
                ? customerBranch?.gstNo : customerDetails?.gstNumber ? customerDetails?.gstNumber
                  : 'N/A'}
              {/* {customerDetails?.gstNumber ? customerDetails?.gstNumber : 'N/A'}{' '} */}
            </TableCell>
          </TableRow>
          <TableRow key={8} className="noBorder"
            style={{
              opacity:
                (
                  policyDetail?.parentqcData ||
                  policyDetail?.insurancePolicy?.qcData
                )?.insured_details?.status === 'approve'
                  ? 0.5
                  : 1,
              pointerEvents:
                (
                  policyDetail?.parentqcData ||
                  policyDetail?.insurancePolicy?.qcData
                )?.insured_details?.status === 'approve'
                  ? 'none'
                  : 'auto',

            }}>
            <TableCell
              className="tbCol"
              component="th"
              scope="row"
              style={activeCellStyle}
            >
              PAN No
            </TableCell>
            <TableCell
              className="tbCol"
              style={activeCellStyle}
            >
              {customerDetails?.pan ? customerDetails?.pan : 'N/A'}{' '}
            </TableCell>
          </TableRow>
          <TableRow key={2} className="noBorder"
            style={{
              opacity:
                (
                  policyDetail?.parentqcData ||
                  policyDetail?.insurancePolicy?.qcData
                )?.insured_details?.status === 'approve'
                  ? 0.5
                  : 1,
              pointerEvents:
                (
                  policyDetail?.parentqcData ||
                  policyDetail?.insurancePolicy?.qcData
                )?.insured_details?.status === 'approve'
                  ? 'none'
                  : 'auto',

            }}>
            <TableCell
              className="tbCol"
              component="th"
              scope="row"
              style={activeCellStyle}
            >
              Product
            </TableCell>
            <TableCell
              className="tbCol"
              style={activeCellStyle}
            >
              {rfqDetails?.policyProduct?.name ?? 'N/A'}
            </TableCell>
          </TableRow>
          <TableRow key={3} className="noBorder"
            style={{
              opacity:
                (
                  policyDetail?.parentqcData ||
                  policyDetail?.insurancePolicy?.qcData
                )?.insured_details?.status === 'approve'
                  ? 0.5
                  : 1,
              pointerEvents:
                (
                  policyDetail?.parentqcData ||
                  policyDetail?.insurancePolicy?.qcData
                )?.insured_details?.status === 'approve'
                  ? 'none'
                  : 'auto',

            }}>
            <TableCell
              className="tbCol"
              component="th"
              scope="row"
              style={activeCellStyle}
            >
              RFQ No
            </TableCell>
            <TableCell
              className="tbCol"
              style={activeCellStyle}
            >
              {rfqDetails.id}
            </TableCell>
          </TableRow>
        </>
      )}
    </>
  );
}

export default PlacementSlipCustomerDetails;
